var React = require('react');

function FRInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2275_5130)","key":0},[React.createElement("rect",{"width":"13","height":"24","fill":"#002494","key":0}),React.createElement("rect",{"x":"25","width":"13","height":"24","fill":"#ED2939","key":1}),React.createElement("rect",{"x":"13","width":"12","height":"24","fill":"#F7F7F7","key":2})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2275_5130"},React.createElement("rect",{"width":"38","height":"24","fill":"white"})))]);
}

FRInline.defaultProps = {"width":"38","height":"24","viewBox":"0 0 38 24","fill":"none"};

module.exports = FRInline;

FRInline.default = FRInline;
